import { PATHS } from 'common/constants';
import binanceIcon from 'assets/image/courses/binance.webp';
import binancePreview from 'assets/image/courses/binancePreview.webp';


// Курсы, которых нет в /api/v1/courses/: у них своя страница, а не /course/:slug.
// Поля — как у курса с бэкенда, плюс to — куда ведёт карточка.
export const BINANCE_COURSE = {
  slug: 'binance-x-geeks',
  to: PATHS.binanceGeeks,
  title: 'Binance x Geeks: Web3',
  description:
    'Практические курсы по Web3 от Geeks при поддержке Binance: блокчейн, криптовалюты, ' +
    'безопасность цифровых активов и трейдинг на симуляторе без риска.',
  active_icon: binanceIcon,
  active_icon_alt: 'Курсы Binance x Geeks',
  inactive_preview_image: binancePreview,
  inactive_preview_image_alt: 'Курсы Binance x Geeks',
};

// Ссылка на страницу курса: своя у курсов-лендингов, иначе /course/:slug.
export const courseLink = (course) => course?.to || `/course/${course?.slug}`;

// Добавляет Binance первым в список курсов с бэкенда (пустой список не трогаем —
// блоки, которые без курсов скрываются, должны скрываться и дальше).
export const withExtraCourses = (courses = []) =>
  courses.length ? [ BINANCE_COURSE, ...courses ] : courses;
